export const strings = {
  en: {
    ctaTitle: () => `Choose Your Impact`,
    ctaMessagePrefix: () => ` at no extra cost, with every order of your subscription.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,`,
    submitButtonText: () => `Confirm`,
    submitButtonTextCompleted: () => `Confirmed!`,
    chooseButtonText: () => `Choose`,
  },
  fr: {
    ctaTitle: () => `Choisissez votre impact`,
    ctaMessagePrefix: () => ` sans frais supplémentaires, à chaque commande de votre abonnement.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choisissez une association et ${donationPercentage} sera reversé en votre nom,`,
    submitButtonText: () => `Confirmer`,
    submitButtonTextCompleted: () => `Confirmé !`,
    chooseButtonText: () => `Choisir`,
  },
  de: {
    ctaTitle: () => `Wähle deinen Impact`,
    ctaMessagePrefix: () => ` ohne zusätzliche Kosten, bei jeder Bestellung deines Abonnements.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Wähle eine gemeinnützige Organisation und ${donationPercentage} werden in deinem Namen gespendet,`,
    submitButtonText: () => `Bestätigen`,
    submitButtonTextCompleted: () => `Bestätigt!`,
    chooseButtonText: () => `Wählen`,
  },
  es: {
    ctaTitle: () => `Elige tu impacto`,
    ctaMessagePrefix: () => ` sin coste adicional, con cada pedido de tu suscripción.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Elige una organización sin ánimo de lucro y donaremos ${donationPercentage} en tu nombre,`,
    submitButtonText: () => `Confirmar`,
    submitButtonTextCompleted: () => `¡Confirmado!`,
    chooseButtonText: () => `Elegir`,
  },
  it: {
    ctaTitle: () => `Scegli il tuo impatto`,
    ctaMessagePrefix: () => ` senza costi aggiuntivi, a ogni ordine del tuo abbonamento.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Seleziona un'organizzazione no-profit e l’${donationPercentage} sarà donato a tuo nome,`,
    submitButtonText: () => `Confermare`,
    submitButtonTextCompleted: () => `Confermato!`,
    chooseButtonText: () => `Scegli`,
  },
  pl: {
    ctaTitle: () => `Wybierz swój wpływ`,
    ctaMessagePrefix: () => ` bez żadnych dodatkowych kosztów, przy każdym zamówieniu w ramach subskrypcji.`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Wybierz organizację non-profit, a ${donationPercentage} zostanie przekazane w Twoim imieniu,`,
    submitButtonText: () => `Zatwierdź`,
    submitButtonTextCompleted: () => `Zatwierdzono!`,
    chooseButtonText: () => `Wybierz`,
  },
  ja: {
    ctaTitle: () => `寄付先をお選びください。`,
    ctaMessagePrefix: () => `追加費用なしで、ご購入ごとに、`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `非営利団体を選ぶと、${donationPercentage}がその団体に寄付されます、`,
    submitButtonText: () => `確認する`,
    submitButtonTextCompleted: () => `確認済み`,
    chooseButtonText: () => `選択してください`,
  },
};
